import { render, staticRenderFns } from "./BarsWithAverage.vue?vue&type=template&id=3036c312&scoped=true"
import script from "./BarsWithAverage.vue?vue&type=script&lang=js"
export * from "./BarsWithAverage.vue?vue&type=script&lang=js"
import style0 from "./BarsWithAverage.vue?vue&type=style&index=0&id=3036c312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3036c312",
  null
  
)

export default component.exports